import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../../components/table/SearchGrid';
import Breadcrums from '../../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RefreshIcon from '@material-ui/icons/Refresh';
import { PostDataAPI } from '../../../../Services/APIService';
import Loader from '../../../../components/Loader/Loader';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../../components/Message/Alert";
import { formatDateTime, getLocalDateFromUTC } from '../../../../../src/components/Common/Extensions';
//import CreatePressRelease from './createPressRelease/CreatePressRelease';
import CreatePressRelease from './createPressRelease/CreatePressRelease';
import PressReleaseEmailPreview from './pressReleaseEmail/Preview';
import * as signalR from "@microsoft/signalr";



function PressRelease({ trackingType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [newPressRelease, setNewPressRelease] = useState(false);
    const [pressRelease, setPressRelease] = useState([]);
    const [releaseStatus, setReleaseStatus] = useState([]);
    const OpenNewPressRelease = () => {
        setNewPressRelease(true)
    }

    const CloseNewPressRelease = () => {
        setNewPressRelease(false)
    }


    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({});


    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [addressBook, setAddressBook] = useState([]);


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }


    const [filteredStatus, setFilteredStatus] = useState([]);


    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };

    const loadPressReleaseGrid = () => {
        setIsLoading(true);
        PostDataAPI("fdnemployeepressrelease/loadGrid").then((result) => {
            if (result.success && result.data != null) {
                console.log(result.data);
                var record = result.data.map((item, i) => {
                    item.createDate = formatDateTime(getLocalDateFromUTC(item.createDate));
                    item.openRate = item.emailOpenCount > item.emailSentCount ? item.emailSentCount : item.emailOpenCount;
                    if (item.scheduleDateTime) {
                        item.scheduleDateTime = getLocalDateFromUTC(item.scheduleDateTime);
                    }

                    return { ...item };
                })
                setPressRelease(record);
            }
            else {
                setPressRelease([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }
    const handleSuccessClose = (message) => {
        CloseNewPressRelease();
        showMessage("Success", message, "success", 3000);
        loadPressReleaseGrid();
    }
    const [previewPressEmailDialog, setPreviewPressEmailDialog] = useState(false);
    const openPressReleasePreview = (item) => {
        setEditItem(item);
        setPreviewPressEmailDialog(true)
    }

    const closePressReleasePreview = () => {
        setPreviewPressEmailDialog(false);
    }
    const handleActionClick = (key, item) => {
        setPreviewPressEmailDialog(false);
        switch (key) {
            case 'preview':
                openPressReleasePreview(item)
                break;
        }
    }
    const deletePressRelease = (record) => {
        showActionDialog("Are you sure you want to delete press release?", "confirm", function () {
            setIsLoading(true);
            var method = "fdnemployeepressrelease/delete";

            var params = { pressReleaseId: record.pressReleaseId, distributionListId:0 }
            PostDataAPI(method, params, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        setIsLoading(false);
                        handleSuccessClose("Press release deleted successfully.");

                    }
                    else {
                        showMessage("Error", "Error deleting press release, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        });
    }
    const getPressReleaseStatus = () => {
        let baseUrl = sessionStorage.getItem('server_api_url');
        //alert(baseUrl);
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(baseUrl.replace("/api","") + "ffHub")
            .build();

        connection.on("PressRelease", (message) => {
            if (message == 'update') {
                setReleaseStatus([...releaseStatus, message]);
                loadPressReleaseGrid();
            }
        });

        connection.start().then(() => {
            const signalRConnectionId = sessionStorage.getItem('signalRConnectionId');
            console.log('Connection ID:', signalRConnectionId);
        }).catch(err => console.error(err));

        return () => {
            connection.stop();
        };
    }
    useEffect(() => {
        loadPressReleaseGrid();
        getPressReleaseStatus();
    }, [releaseStatus]);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            {/* <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Press Release"} isBack={false}></Breadcrums>
                    </Grid>
                </Grid>
            </div> */}

            <Grid row className={classes.gridHeader}>

                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => loadPressReleaseGrid()}><RefreshIcon style={{ marginRight: '6px' }} /> <span> Refresh </span></Button>
                    <Button className={classes.changeBtn} onClick={() => OpenNewPressRelease()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> <span> Create New Press Release </span></Button>
                </div>


                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid columns="PressRelease"
                    list={pressRelease}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onDeleteClick={deletePressRelease}
                    onActionClick={handleActionClick}
                />
            </Grid>


            {newPressRelease ?
                <CreatePressRelease
                    dialogOpenClose={OpenNewPressRelease}
                    handleClose={CloseNewPressRelease}
                    handleSuccessClose={handleSuccessClose}> </CreatePressRelease > : ""
            }
            {previewPressEmailDialog ?
                <PressReleaseEmailPreview
                    dialogOpenClose={openPressReleasePreview}
                    handleClose={closePressReleasePreview}
                    record={editItem}
                > </PressReleaseEmailPreview > : ""
            }
            



<ActionDialog
    type={actiondialogState.type}
    message={actiondialogState.message}
    actiondialogOpenClose={actiondialogState.showHide}
    onSubmit={actiondialogState.onClickOk}
    onCancel={() =>
        setActionDialogState(prevState => ({
            ...prevState, showHide: false
        }))
    }
    onClose={() => setActionDialogState(prevState => ({
        ...prevState, showHide: false
    }))

    }
/>

        </>
    )

}

export default withSnackbar(PressRelease);